<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>充电桩记账</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form :inline="true" class="user-search">
      <el-form-item label="日期：">
        <el-date-picker size="small" style="width: 240px" v-model="dateRange" type="daterange" value-format="yyyy-MM-dd"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd" v-if="$canEntry()">记一笔</el-button>
      </el-form-item>
      <el-form-item>
        <span class="summary">共 {{ pageparm.total }} 笔，合计 {{ amountTotal }} 元（不计入收支和余额）</span>
      </el-form-item>
    </el-form>
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border style="width: 100%;">
      <el-table-column prop="recordDate" label="日期" width="140"></el-table-column>
      <el-table-column prop="recordType" label="类型" width="140"></el-table-column>
      <el-table-column prop="amount" label="数额" width="140"></el-table-column>
      <el-table-column prop="notes" label="备注" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="操作" width="180" v-if="$canManage()">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <el-dialog :title="editForm.id ? '修改充电桩记录' : '记一笔充电桩'" :visible.sync="editFormVisible" width="420px">
      <el-form label-width="90px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="日期" prop="recordDate">
          <el-date-picker size="small" style="width: 220px" v-model="editForm.recordDate" type="date"
                          value-format="yyyy-MM-dd" :picker-options="{ disabledDate: d => d > new Date() }" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="类型">
          <el-select size="small" style="width: 220px" v-model="editForm.recordType" allow-create filterable>
            <el-option v-for="t in typeOptions" :key="t" :label="t" :value="t"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数额" prop="amountChoice">
          <el-select size="small" style="width: 220px" v-model="editForm.amountChoice">
            <el-option v-for="a in amountOptions" :key="a" :label="a + ' 元'" :value="a"></el-option>
            <el-option label="其他金额" value="other"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="其他金额" prop="customAmount" v-if="editForm.amountChoice === 'other'">
          <el-input size="small" style="width: 220px" v-model="editForm.customAmount" placeholder="如 1500 或 800"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input size="small" style="width: 220px" v-model="editForm.notes" placeholder="选填"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import { queryChargingPage, saveCharging, deleteCharging } from '../../api/realTimeBill'

// 大部分是 2000，其余也都是整千；非整千选「其他金额」手填
const AMOUNTS = [2000, 1000, 3000, 4000, 5000, 6000]

function today() {
  const d = new Date()
  return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2)
}

export default {
  components: { Pagination },
  data() {
    return {
      loading: false,
      saving: false,
      dateRange: null,
      listData: [],
      amountTotal: 0,
      pageparm: { currentPage: 1, pageSize: 20, total: 0 },
      editFormVisible: false,
      editForm: {},
      amountOptions: AMOUNTS,
      typeOptions: ['充电桩支出', '充电桩收入'],
      rules: {
        recordDate: [{ required: true, message: '请选择日期', trigger: 'change' }],
        amountChoice: [{ required: true, message: '请选择数额', trigger: 'change' }],
        customAmount: [{
          validator: (rule, value, callback) => (Number(value) > 0) ? callback() : callback(new Error('请输入大于 0 的金额')),
          trigger: 'blur'
        }]
      }
    }
  },
  created() {
    this.getdata()
  },
  methods: {
    getdata() {
      this.loading = true
      const [dateFrom, dateTo] = this.dateRange || []
      queryChargingPage({ current: this.pageparm.currentPage, size: this.pageparm.pageSize, dateFrom, dateTo })
        .then(res => {
          this.loading = false
          if (res.code !== '200') return this.$message({ type: 'info', message: res.message })
          this.listData = res.data.content
          this.pageparm.total = res.data.total
          this.amountTotal = res.data.amountTotal
        })
        .catch(() => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试')
        })
    },
    search() {
      this.pageparm.currentPage = 1
      this.getdata()
    },
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getdata()
    },
    handleAdd() {
      this.editForm = { recordDate: today(), recordType: '充电桩支出', amountChoice: 2000, customAmount: '', notes: '' }
      this.editFormVisible = true
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate())
    },
    handleEdit(row) {
      const amount = Number(row.amount)
      const preset = AMOUNTS.indexOf(amount) >= 0
      this.editForm = {
        id: row.id,
        recordDate: row.recordDate,
        recordType: row.recordType,
        amountChoice: preset ? amount : 'other',
        customAmount: preset ? '' : String(amount),
        notes: row.notes
      }
      this.editFormVisible = true
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate())
    },
    submit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        const f = this.editForm
        const amount = f.amountChoice === 'other' ? Number(f.customAmount) : f.amountChoice
        this.saving = true
        saveCharging({ id: f.id, recordDate: f.recordDate, recordType: f.recordType, amount, notes: f.notes })
          .then(res => {
            this.saving = false
            if (res.code !== '200') return this.$message({ type: 'info', message: res.message })
            this.editFormVisible = false
            this.$message({ type: 'success', message: '已保存' })
            this.getdata()
          })
          .catch(() => {
            this.saving = false
            this.$message.error('保存失败，请稍后再试')
          })
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除 ' + row.recordDate + ' 的 ' + row.amount + ' 元吗？', '删除充电桩记录', { type: 'warning' })
        .then(() => deleteCharging([row.id]))
        .then(res => {
          if (res.code !== '200') return this.$message({ type: 'info', message: res.message })
          this.$message({ type: 'success', message: '已删除' })
          this.getdata()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.summary {
  color: #606266;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/realTimeBill/charging.vue